import React, { useEffect } from 'react'
import styled from 'styled-components'
import { up } from 'styled-breakpoints'

import Loader from '../../loader'
import PopUp from '../../pop-up'
import SearchItem from './item'

import { useAuth } from '../../../../data/hooks/auth'
import { useBookSearch } from '../../../../data/hooks/book'

type SearchDropdownProps = {
  isOpen: boolean
  query: string | null
  onClick?: () => void
}

const SearchDropdown: React.FunctionComponent<SearchDropdownProps> = ({ query, isOpen, onClick }) => {
    const user = useAuth()

    const [state, update] = useBookSearch()

    return (
      <SearchPopUp
        onBottomReached={() => update(query || "", state.books?.length || 0, 10)}
        bottomStopCondition={() => state.final || state.pending}
        dependencies={[user.token, query, isOpen]}
        isOpen={isOpen}
        reset={() => update(query || "", 0, 10, true)}
      >
        {
          state.books?.map(el => <SearchItem book={el} key={el.id} onClick={onClick}/>)
        }
        {
          state.pending && <Loader />
        }
      </SearchPopUp>
    )
}

const SearchPopUp = styled(PopUp)`
  right: 0;
  left: auto;
  width: 600px;
  padding-top: 20px;

  height: calc(100vh - 100% - 1);
  max-height: calc(100vh - 100%);

  ${up('tablet')} {
    max-height: 70vh;
  }

  z-index: 12; // over other popups
`


export default SearchDropdown